module.exports = __webpack_public_path__ + "img/4.949814c3.jpg";